import sentGAEvent from ".";

/**
 * 注册页面出现曝光埋点
 */
const GASignUpPageDisplay = () => {
  sentGAEvent({
    category: "sign_up",
    action: "sign_up_display",
  });
};

/**
 * 点击注册按钮
 */
const GASignUpClickConfirm = () => {
  sentGAEvent({
    category: "sign_up",
    action: "sign_confirm_click",
  });
};

/**
 * 注册表单格式报错
 * @param {string} label
 */
const GASignUpFromError = label => {
  sentGAEvent({
    category: "sign_up",
    action: "sign_up_error",
    label,
  });
};

/**
 * 注册页面跳转login页面
 */
const GASignUpClickToLogin = () => {
  sentGAEvent({
    category: "sign_up",
    action: "sign_to_login_click",
  });
};

/**
 * 注册页面跳转设置密码页面
 */
const GALoginClickToSetPassowrd = () => {
  sentGAEvent({
    category: "sign_up",
    action: "sign_setpassword_click",
  });
};



export {
  GASignUpPageDisplay,
  GASignUpClickConfirm,
  GASignUpFromError,
  GASignUpClickToLogin,
  GALoginClickToSetPassowrd,
};
